import React from 'react';
import useWidth from './useWidth';

export default function withUseWidth(Component) {
  return (props) => {
    const screenWidth = useWidth();
    return <Component screenWidth={screenWidth} {...props} />;
  };
}
